import 'css-chunksrc/client/pages/projectPage/kanbanPage/column/task/tagList/styles.scss';export default {
  "tagList": "_tagList_e37uk_1",
  "list": "_list_e37uk_9",
  "tag": "_tag_e37uk_1",
  "removeIcon": "_removeIcon_e37uk_40",
  "slideRemoveIcon": "_slideRemoveIcon_e37uk_1",
  "iconBox": "_iconBox_e37uk_58",
  "icon": "_icon_e37uk_58",
  "form": "_form_e37uk_72"
};